module.exports = __webpack_public_path__ + "img/about-yellow.eab200c1.png";